<template>
  <fts-dropdown-select
    append-to-body
    :placement="placement"
    prevent-overflow-alt-axis
    prevent-overflow-tether-off
    content-class="dropdown-menu dropdown-menu-w-xs"
    reference-id="fts-confirmation"
    :reference-for="referenceFor"
    overlay
    @show="onShow"
    @hide="onHide"
  >
    <slot slot="toggle">
      <fts-state :state="state" />
    </slot>
    <template #menu="{ select }">
      <div class="dropdown-form">
        <input
          class="fts-form-control"
          name="state-name"
          v-model="formData.name"
          ref="designName"
          @input="$v.formData.$touch()"
        />
        <div class="dropdown-form-error" v-if="$v.formData.name && $v.formData.name.$error">
          {{getStateDesignError('name')}}
        </div>
      </div>
      <div class="dropdown-divider"></div>
      <div class="dropdown-label">Colors</div>
      <div class="dropdown-form">
        <swatches
          v-model="formData.color"
          shapes="circles"
          row-length="7"
          :swatches="colors"
          :swatch-size="24"
          inline
          background-color="var(--fts-popover-alt-background)"
        />
      </div>
      <div class="dropdown-divider"></div>
      <div class="dropdown-option" @click="onDelete(select)">
        <div class="dropdown-option-icon">
          <font-awesome-icon :icon="['far', 'trash-can']" fixed-width />
        </div>
        <div>Delete state</div>
      </div>
    </template>
  </fts-dropdown-select>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import changesets from 'diff-json';
import Swatches from 'vue-swatches';

import { darkPalette } from '../commons/colors';
import validator from '../commons/designValidator';

import FTSDropdownSelect from '../elements/FTSDropdownSelect';
import FTSState from '../elements/FTSState';

export default {
  components: {
    Swatches,
    'fts-dropdown-select': FTSDropdownSelect,
    'fts-state': FTSState
  },
  props: {
    state: Object,
    states: Array,
    placement: String,
    referenceFor: String
  },
  data: () => ({
    formData: {},
    isDelete: false
  }),
  validations() {
    let formData = {};
    formData = validator.stateDesign(this.states);
    return { formData };
  },
  methods: {
    onShow() {
      this.formData = _.cloneDeep(this.state);
      this.$nextTick(() => {
        this.$refs.designName.focus();
      });
    },
    onHide() {
      if (!this.isDelete) {
        const diff = changesets.diff(this.formData, this.state);
        if (!this.$v.formData.$invalid && diff.length) {
          this.$emit('state:update', this.formData);
        }
      }
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    async onDelete(select) {
      const res = await this.$confirmation.show({
        type: "delete",
        title: "State",
        text: this.formData.name,
        backgroundColor: this.formData.color
      });

      if (res === true) {
        this.isDelete = true;
        this.$emit("state:delete");
        select && select();
      }
    },
    getStateDesignError(key) {
      return validator.stateDesignError(this.$v.formData, key);
    }
  },
  created() {
    this.colors = darkPalette;
  }
}
</script>